import React, { useState } from 'react'
import { Button, Form } from 'reactstrap'
import { notify, prefix } from '../../../utils/index_tagging_tool'

import SettingsBox from './ConfigurationBox/SettingsBox'
import InputBox from './ConfigurationBox/InputBox'
import OutputBox from './ConfigurationBox/OutputBox'
import { useFileUpload } from '../../../hooks'

function SeoConfiguration({
  reportId,
  reportFile,
  reportClient,
  reportLanguage,
  reportLingua,
  reportKw,
  reportVol,
  reportOutput,
  reportName,
  reportGroups,
  groupOptions,
  updateReport,
}) {
  const [nome, setNome] = useState(reportName)
  const [nomeError, setNomeError] = useState(false)
  const [gruppi, setGruppi] = useState(reportGroups)
  const [file, setFile] = useState(null)
  const [fileMode, setFileMode] = useState('a')
  const [editFile, setEditFile] = useState(false)
  const [client, setClient] = useState(reportClient)
  const [language, setLanguage] = useState(reportLanguage)
  const [lingua, setLingua] = useState(reportLingua)
  const [kw, setKw] = useState(reportKw)
  const [vol, setVol] = useState(reportVol)

  const { upload, loading } = useFileUpload()
  const [running, setRunning] = useState(false)

  const ratio = {
    title: 3,
    form: 4
  }

  // Funzione che contatta il backend per salvare la configurazione aggiornata
  const handleSubmit = async (e) => {
    e.preventDefault()

    let erroreNome = null;
    if (nome === '') erroreNome = 'Non puoi inserire un nome vuoto'
    if (nome.length > 1024) erroreNome = 'Non puoi inserire un nome con più di 1024 caratteri'
    if (/^[ a-zA-Z_0-9]+$/gm.test(nome) === false)
      erroreNome = 'Puoi inserire un nome composto solo di lettere (maiuscole o minuscole), numeri e trattini bassi'
    if (erroreNome) {
      notify(erroreNome, 'warning')
      setNomeError(true)
      return
    }

    let formData = new FormData()
    formData.append('nome', nome)
    formData.append('gruppi', JSON.stringify(gruppi))
    formData.append('client', client)
    formData.append('language_code', language)
    formData.append('language', lingua)
    formData.append('file', file)
    formData.append('fileMode', fileMode)
    formData.append('keyword', kw)
    formData.append('volume', vol)

    try {
      const data = await upload('put', prefix + `reports/${reportId}/`, formData,
        {onSuccess: (data) => {
        if (typeof data === 'object') {
          notify('Configurazione modificata con successo', 'success');
          updateReport(data);
        } else {
          notify(
            'Qualcosa è andato storto, ricontrollare o contattare un innovation',
            'error'
          )
        }
      }})
    } catch (err) {
      console.error('Configuration update failed:', err)
    }
  }

  return (
    <div className="Content-box mt-2">
      <Form onSubmit={handleSubmit} className="SeoConfigurationForm">
        <SettingsBox
          nome={nome}
          setNome={setNome}
          nomeError={nomeError}
          setNomeError={setNomeError}
          gruppi={gruppi}
          gruppiOptions={groupOptions}
          setGruppi={setGruppi}
          lingua={lingua}
          setLingua={setLingua}
          ratio={ratio}
        />
        <hr className="mt-4 mb-4"/>
        <InputBox
          file={file}
          fileMode={fileMode}
          setFile={setFile}
          setFileMode={setFileMode}
          editFile={editFile}
          setEditFile={setEditFile}
          reportFile={reportFile}
          client={client}
          setClient={setClient}
          language={language}
          setLanguage={setLanguage}
          keyword={kw}
          setKeyword={setKw}
          volume={vol}
          setVolume={setVol}
          ratio={ratio}
        />
        <hr className="mt-4 mb-4"/>
        <OutputBox options={reportOutput} ratio={ratio}/>
        <div className="text-center">
          {loading ? (
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <Button color="success">
              Salva modifiche
            </Button>
          )}
        </div>
      </Form>
    </div>
  )
}

export default SeoConfiguration
